$(document).ready(function(){
  var playerSlider = $('.player-sliders').slick({
    slidesToShow: 4,
    SlidesToScroll: 1,
    infinite: false,
    dots:true,
    responsive: [
        {
          breakpoint:550,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
  });
  $('.players-tab-button').click(function(e){
      e.preventDefault();
      var currentIndex = $(this).index();
      $(this).addClass('active').siblings().removeClass('active');
      $('.player-sliders-wrap').eq(currentIndex).addClass('active').siblings().removeClass('active');
      playerSlider.slick('refresh')
    })
})